/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Download_DescriptionInputs */

const en_cad_page_download_description = /** @type {(inputs: Cad_Page_Download_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download ArtCraft CADCraft v0.8.0 free for Windows, macOS, Linux and FreeBSD. Step-by-step install guide, checksums, build from source and the web version.`)
};

/**
* | output |
* | --- |
* | "Download ArtCraft CADCraft v0.8.0 free for Windows, macOS, Linux and FreeBSD. Step-by-step install guide, checksums, build from source and the web version." |
*
* @param {Cad_Page_Download_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_download_description = /** @type {((inputs?: Cad_Page_Download_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Download_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_download_description(inputs)
});
export { cad_page_download_description as "cad.page.download.description" }